import React from 'react';
import Layout from '../components/Layout';
import { Mail, Github, Link as LinkIcon } from 'lucide-react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <Layout>
      <div className="contact-container">
        <h2>Contact</h2>
        <ul className="contact-list">
          <li>
            <Mail size={20} />
            <span>watanabe.maoto.21@shizuoka.ac.jp</span>
          </li>
          <li>
            <Github size={20} />
            <a href="https://github.com/maoto-wata" target="_blank" rel="noopener noreferrer">
              github.com/maoto-wata
            </a>
          </li>
          <li>
            <LinkIcon size={20} />
            <a href="https://shoji-lab.github.io/" target="_blank" rel="noopener noreferrer">
              莊司研究室ウェブサイト
            </a>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default Contact;
